module.exports = __webpack_public_path__ + "static/the-culting-of-brands-0288835adec1e5ed7bf9b5023dc627b0.jpg";